import axios from "@/app/axios";

const getArtists = () => {
  return axios.get(`api/artists`).then((res) => {
      return res.data.artists as IArtistItem[];
  });
};

const getArtist = (slug: string) => {
  return axios.get(`api/artist/${slug}`).then((res) => {
      return res.data.artist as IArtistDetails;
  });
};

const ArtistsService = {
    getArtists,
    getArtist
};

export default ArtistsService;
